export default function needsOffset (m) {
	return !!(m._a && (m._tzm === undefined));
}



// WEBPACK FOOTER //
// ./node_modules/moment-timezone/src/moment/needs-offset.js